function addClickListeners() {
    const enjoymentTripItems = document.querySelectorAll('.enjoyment-trip-item');
    const body = document.querySelector('body');

    enjoymentTripItems.forEach(function (enjoymentTripItem) {
        enjoymentTripItem.addEventListener('click', function () {
            if (!enjoymentTripItem.classList.contains('show')) {
                enjoymentTripItem.classList.add('show');
                body.classList.add('js-enjoyment-trip-item-open');
            }
        });

        const closeButton = enjoymentTripItem.querySelector('.enjoyment-trip-item__close');

        if (closeButton) {
            closeButton.addEventListener('click', function (e) {
                e.stopPropagation();
                enjoymentTripItem.classList.remove('show');
                body.classList.remove('js-enjoyment-trip-item-open');
            });
        }
    });
}

function checkWindowWidth() {
    if (window.innerWidth <= 1025) {
        addClickListeners();
    }
}

checkWindowWidth();

window.addEventListener('resize', function () {
    checkWindowWidth();
});
